import { IPatientNotificationRulesStore } from './types';

const initStore: IPatientNotificationRulesStore = {
  items: [],
};

export default initStore;
